import { Box } from "@chakra-ui/react";
import React from "react";
import { Text } from "../Text";
import { colors } from "../../theme/colors";

interface IChipProps {
	text: string;
}

export const Chip = ({ text }: IChipProps) => (
	<Box
		padding={"8px 16px"}
		margin={"16px 0 16px 0"}
		borderRadius={"36px"}
		display={"inline-flex"}
		gap={"4px"}
		justifyContent={"flex-start"}
		alignItems={"center"}
		bgColor={colors.gray[600.2]}
		w="auto"
		overflowX="auto"
		maxW={"100%"}
	>
		<Text preset="preset3" lineHeight='16px' fontSize='14px' color={colors.gray[600]} fontWeight="medium">
			{text}
		</Text>
	</Box>
);
